import { IBetPositionByService } from '../../../../types/reducers/betPosition';
import { mapBetPosition } from './mapBetPosition';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import { IGetBetsPositionResponse } from '../../../../repositories/auction/entities/AnnouncementsBets/GetBetsPositionResponse';
import { EServices } from '../../../../repositories/monolith-python/entities/publish_terms/PublishTermSchema';

export const mapBetsByServices = (betsByServices: IGetBetsPositionResponse['betsByServices']) => {
  return Object.entries(betsByServices).reduce<IBetPositionByService>((acc, [service, betPosition]) => {
    if (!betPosition) {
      return acc;
    }

    const mappedBetPosition = mapBetPosition(betPosition);

    switch (service) {
      case EServices.Top3:
        acc[EServiceId.top] = mappedBetPosition;

        break;

      case EServices.Premium:
        acc[EServiceId.premium] = mappedBetPosition;

        break;

      case EServices.Paid:
        acc[EServiceId.paid] = mappedBetPosition;

        break;

      case EServices.Free:
        acc[EServiceId.free] = mappedBetPosition;

        break;
    }

    return acc;
  }, {});
};
